module.exports = __webpack_public_path__ + "img/baseball_pic_1728x838-orig.5af9985f.png";